export default __webpack_public_path__ + "static/media/baby-kitties.1f9cdea0.jpeg";